export default "__VITE_ASSET__b92484e7__"